import { Employee } from "@skbkontur/staff-common";
import { EmployeeListInitialState } from "@skbkontur/staff-selector-widget";

import { Deferred } from "../../../Helpers/Deferred";
import { ImportFromEmployeeServiceOptions } from "../../EmployeeServiceTypes";

export enum ImportEmployeesActionType {
    BeginImport = "ImportEmployeesAction.BeginImport",
    EndImport = "ImportEmployeesAction.EndImport",
}

export type ImportEmployeesAction =
    | {
          type: ImportEmployeesActionType.BeginImport;
          payload: {
              deferredResult: Deferred<Employee[] | undefined>;
              initialState?: EmployeeListInitialState;
              options?: ImportFromEmployeeServiceOptions;
          };
      }
    | {
          type: ImportEmployeesActionType.EndImport;
      };
